import {Screen} from '../../Common/stores/Screen';
import {ContainersCollection} from './ContainersCollection';

export class ContainersScreen extends Screen {
    sysBasicLang;
    sysCurrLang;
    exprFunc;
    exprPredefined;
    ops;
    forValue;

    constructor(screen, name) {
        super(screen, name);
        this.sysBasicLang = screen.sysBasicLang;
        this.sysCurrLang = screen.sysCurrLang;
        this.updateScreen(screen);
        this.collection = new ContainersCollection(null);
    }

    updateScreen(screen) {
        this.exprFunc = screen.exprFunc;
        this.exprPredefined = screen.exprPredefined;
        this.ops = screen.ops;
        this.forValue = screen.forValue;
    }

    setCollection(data) {
        this.collection.insertFields(this, data.fields, data.fieldsToShow);
    }
}
